import React, { useReducer, useEffect } from "react"; // FB 4533
import { AppBar, Toolbar, Typography, Card } from "@material-ui/core";
import StartPage from "./appointments/create/index";
import Demographics from "./appointments/create/components/Demographics";
//FB 4553 DK - Moved logo to config.js
import { BrowserRouter, Route, Switch } from "react-router-dom";
import SlotsPage from "./appointments/create/inoffice/slots_byprovider";
import LocationSlotsPage from "./appointments/create/inoffice/slots_bylocation";
import DateSlotsPage from "./appointments/create/inoffice/slots_bydate";
import Confirmation from "./appointments/create/confirmationPage";
import Reviews from "./components/reviews";
import {
  Context,
  initialState,
  Store,
} from "./appointments/create/store/index";
import reducer from "./appointments/create/store/reducer";
import useStyles from "./appointments/create/css/styles";
import Thankyou from "./components/Thankyou";
import Configurations from "./config";      //FB 4472 DK - Added to import configurations from config.js.sample
import { TrackJS } from 'trackjs';    //FB 4553 DK - Added import for track.js
import apptConfirmation from "./components/Appointmentconfirm";	//FB 4660 BR    PE - Appointment confirmation url
import parkinglotConfirmation from "./components/Parkinglotconfirm";  //FB 4661 BR PE - ParkingLot confirmation url
import page_redirector from "./appointments/create/page_redirector";  //FB 4763 DK - Added reference to page
import ReactGA from 'react-ga';   //FB 4533 : BR GA tags for patient engagement
//FB 4867 DK - Added references for pages
import UploadPage from "./appointments/create/upload";
import PatientVerificationPage from "./components/Verification";
import LandingPage from "./components/Landingpage";
import Finalpage from "./components/Finalpage";
import globalsettings from "./config"; //FB 4960
import Video from "./twilio/videoChat";	//FB 6036
import Importphotos from "./components/Importphotos"; //FB 6025
import Capturephotos from "./components/Capturephotos"; //FB 6025
import Upload from "./components/Upload";	//FB 6039
import moment from "moment-timezone"; //FB 7675
import { GetAdminSettingValue } from "./appointments/create/api"; //FB 7917
import addCC from "./appointments/create/components/addCC";//FB 7719
import LoggedOutMessage from "./logout";//FB 8259


// update log
// FB 4371 DK    03/29/2021    Master page where the routing is defined and implemented
// FB 4472 DK    05/31/2021    Logo moved to public->images folder and made as part of config.js
// FB 4498 BR    06/10/2021    Review email for note creation
// FB 4553 DK    07/05/2021    Implementing track.js
// FB 4653 BR    08/23/2021    PE - Text message changed in review emails
// FB 4660 BR    08/30/2021    PE - Appointment confirmation url
// FB 4661 BR    08/30/2021    PE - ParkingLot confirmation url
// FB 4735 DK    10/11/2021    Implementation of provider specific workflow
// FB 4763 DK    10/21/2021    Added new path to redirect short url's
// FB 4533 BR    07/01/2021    GA tags for patient engagement
// FB 4867 DK    12/27/2021    Added screens for Support files upload and Health forms
// FB 4960 BR    03/11/2022    Logging all actions on PE
// FB 6036 MS    05/17/2022    Telehealth
// FB 6025 BR    04/26/2022    PE - Import Photos through QR code scan from smartphone
// FB 6039 DK    06/28/2022    QR code changes
// FB 6109 DK    08/24/2022    Consent form integration changes
// FB 6140 DK    09/19/2022    Removed comment from Header
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 6963 AS		 06/09/2023    Renamed vars for clarity
// FB 7675 DK    11/09/2023    Timezone handling for appointments
// FB 7917 DK    12/15/2023    Timezone handling with admin setting
// FB 7719 SK    02/13/2024    PE- option to add credit card on file while booking an appointment
// FB 8259 SK    02/28/2024    After booking appt with card details when user click back button needs to be handled
// FB 8290 MS    04/29/2024    Get practice logo from EMR
// FB 8680 DK    05/21/2024    Practice phone related changes
// FB 10587 BH   05/14/2025    Removed Licensee name from thr URL


//FB 4533 : BR-Start GA tags for patient engagement
function usePageViews() {
  useEffect(
    () => {
      ReactGA.initialize(Configurations.trackingID);
      ReactGA.pageview(window.location.pathname + window.location.search);
      getIpDetails(); //FB 4960
      GetTimeZoneflag();  //FB 7917
    }, []
  )
}

//FB 4960 BR Start-Logging all actions on PE
export const getIpDetails = async () => {
  try {
    const response = await fetch("https://api64.ipify.org?format=json");
    if (response.ok) {
      const clientDetails = await response.json();
      globalsettings.clientIp = clientDetails.ip;
      return clientDetails.ip;
    } else {
      throw "Error in calling getIpDetails";
    }
  } catch (e) {
    const exceptionMessage = e.message || e;
    console.log(`Error in fetching Ip Details - ${exceptionMessage}`);
    return "";
  }
};

//FB 7917
function GetTimeZoneflag() {
  let timeZoneFlag = sessionStorage.getItem("timeZoneFlag");
  if (timeZoneFlag == null || timeZoneFlag == undefined) {
    GetAdminSettingValue("TimeZoneHandling").then((data) => {
      if (data != null && data != "" && data != undefined) {
        sessionStorage.setItem("timeZoneFlag", data);
      }
    })
  }
}


function App() {
  //FB 4533 : BR-Start GA tags for patient engagement
  usePageViews()
  //FB 4533 : BR- End GA tags for patient engagement
  const styles = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState as Store);

  //FB 8680
  async function getDefaultPhone(){
    var DefaultPhone = await GetAdminSettingValue("Default_Sch_Appt_Number");
    if(DefaultPhone!=null){
      sessionStorage.setItem("DefaultPhone",DefaultPhone);
    }
  }

  //FB-6264
  useEffect(() => {
    //FB 4553 DK - installing track.js
    TrackJS.install({
      token: '281bcfb669fa4d8ebf2836dd4658ef74',
      enabled: window.location.hostname == "localhost" ? false : true,
      version: window.location.hostname
    });
    //FB 7675
    window.sessionStorage.setItem("TimeZone", moment.tz.guess(true));
    getDefaultPhone();  //FB 8680
  }, []);

  return (
    <div>
      <AppBar position="static" className={styles.appBar}>
        <Toolbar>
          <Typography variant="h5" className={styles.appTitle}>
            {/* FB 6140 */}
            {window.location.pathname.includes("tele") ? "Video Conference" : "Book Appointment"}
          </Typography>
        </Toolbar>
      </AppBar>
      <section
        style={{
          maxWidth: !(window.innerWidth < 768) ? "80%" : "100%",
          margin: "auto",
          marginTop: 10,
          //overflowY :"auto"
        }}
      >
        <section
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* FB 4472 DK - Changed the src to pick image from public folder */}
          {/* FB 8290 MS - Changed the src to pick image from EMR folder */}
          <img src={`${globalsettings.emrAPI}img/logo.jpg`} alt="logo" className={styles.logo} />
        </section>
        <Card
          id="a1"
          style={{
            margin: "10px auto auto",
            minHeight: !(window.innerWidth < 768) ? "75vh" : "100vh",
            boxShadow: "0 3px 5px 2px lightgray",
          }}
        >
          <BrowserRouter basename="/appointment/create">
            <Switch>
              <Context.Provider value={{ state, dispatch }}>
                <Route exact path="/:apt/:reg/:loc" component={StartPage} />
                {/*FB 4763 DK - Added regExp to the params*/}
                <Route exact path="/:apt(\d+)/:provider(\d+)" component={StartPage} />	{/*FB 4735 DK - Added route to provider specific flow*/}
                <Route exact path="/" component={StartPage} />
                <Route exact path="/slots_byprovider" component={SlotsPage} />
                <Route
                  exact
                  path="/slots_bylocation"
                  component={LocationSlotsPage}
                />
                <Route exact path="/slots_bydate" component={DateSlotsPage} />
                <Route exact path="/demographics" component={Demographics} />
                <Route
                  exact
                  path="/confirmationPage"
                  component={Confirmation}
                />
                {/* FB 7719*/}
                <Route exact path="/addCC" component={addCC} />
                {/* FB 8259*/}
                <Route exact path="/logout" component={LoggedOutMessage} />
                {/* FB 4498 BR:start update reviews for sessions */}
                <Route exact path="/appointments/reviews/:id/:flag" component={Reviews} />
                {/* FB 4498 BR:end update reviews for sessions */}
                {/* FB 4653 BR - PE - Text message changed in review emails */}
                <Route exact path="/Thankyou/:id" component={Thankyou} />
                {/* FB 4660 BR    PE - Appointment confirmation url */}
                <Route exact path="/appointments/apptConfirmation/:apptId/:licenseName" component={apptConfirmation} />
                {/* FB 4661 BR    PE - ParkingLot confirmation url */}
                <Route exact path="/appointments/parkingLotConfirmation/:apptId/:licenseName" component={parkinglotConfirmation} />
                {/* FB 4763 DK - Added path to redirect short url's */}
                <Route exact path="/redirect/:urlcode" component={page_redirector} />

                {/* FB 4867 DK - Added screens for Support files upload and Health forms - Start*/}
                <Route exact path="/upload/:apptId" component={UploadPage} />
                {/* FB 6109 */}
                <Route exact path={["/appointments/landingPage/:apptType/:apptId/:licenseName/:flag", "/appointments/landingPage/:apptId/:licenseName/:flag"]} component={LandingPage} />
                <Route exact path="/closure" component={Finalpage} />
                <Route exact path="/VerifyPatient/:apptId" component={PatientVerificationPage} />
                {/* FB 4867 DK - Added screens for Support files upload and Health forms - End*/}
                {/*FB 6036*/}
                <Route exact path="/appointment/tele/:patient/:room" component={Video} />
                {/* FB 6025 BR - PE - Import Photos through QR code scan from smartphone - Start */}
                <Route exact path="/appointment/Importphotos/:apptId/:docType" component={Importphotos} />
                <Route exact path="/appointment/Capturephotos/:apptId/:docType" component={Capturephotos} />
                {/* FB 6025 BR - PE - Import Photos through QR code scan from smartphone - End */}
                {/*FB 6039*/}
                <Route exact path="/upload-page/:session_n/:control_name/:tokenId" component={Upload} />   {/*FB 6963 Renamed vars for clarity*/} {/*FB 10587 Removed Licensee  name from thr URL*/}
              </Context.Provider>
            </Switch>
          </BrowserRouter>
        </Card>
      </section>
    </div>
  );
}

export default App;
